import { render, staticRenderFns } from "./ArchiveEdit.vue?vue&type=template&id=71cb6d3e&"
import script from "./ArchiveEdit.vue?vue&type=script&lang=js&"
export * from "./ArchiveEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports